<cfp-modal-content
  [title]="'tags.add' | translate"
  (closeClicked)="close()"
  [attr.data-test]="'addTag'"
  [focusFirstInteractiveChild]="true"
  [dataTest]="'addTagModal'"
>
  <ng-container modal-body>
    <p>{{ 'tags.add.description' | translate }}</p>
    <form [formGroup]="form" id="addTag" (submit)="submit()" #ngForm="ngForm">
      <cfp-form-group>
        <cfp-input-text
          formControlName="tag"
          [placeholder]="'tags.add.tagName.placeholder' | translate"
          [maxLength]="50"
          [hasCdkFocusInitial]="true"
          [dataTest]="'tagNameInput'"
        />
        <cfp-validation-feedback
          [showMessage]="ngForm.submitted"
          [control]="form.controls.tag"
          [name]="'tags.add.tagName' | translate"
        />
      </cfp-form-group>
    </form>
  </ng-container>
  <cfp-button-loading
    modal-footer
    [loading]="saving()"
    [buttonType]="'submit'"
    [buttonForm]="'addTag'"
    [dataTest]="'addTagButton'"
  >
    {{ 'add.button' | translate }}
  </cfp-button-loading>
</cfp-modal-content>
